var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "pause_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pause_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 19q-.825 0-1.412-.587A1.93 1.93 0 0 1 13 17V7q0-.824.588-1.412A1.93 1.93 0 0 1 15 5h2q.824 0 1.413.588Q19 6.175 19 7v10q0 .824-.587 1.413A1.93 1.93 0 0 1 17 19zm-8 0q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 17V7q0-.824.588-1.412A1.93 1.93 0 0 1 7 5h2q.825 0 1.412.588Q11 6.175 11 7v10q0 .824-.588 1.413A1.93 1.93 0 0 1 9 19zm8-2h2V7h-2zm-8 0h2V7H7z"
  }))));
};
export default SvgPause;